export const fillProfile = (profileDetails) => {
    return {
        type: "profile/fill",
        payload: profileDetails,
    };
};